import Env from 'utils/env';
import { getUri } from '../utils/fetch';


// GETs the incidents from statuspage.io
export const getComponents = (signal: AbortSignal): Promise<any> => {
    const additionalOptions = {
        dataType: 'json',
        externalUrl: true
    }
    const uri =  Env.statusPageAPIURL
    .clone()
    .setPath('/api/v2/components.json');
    return getUri(uri, {
        signal
    }, additionalOptions);
}

// GETs the incidents from statuspage.io
export const getSystemStatus = (signal: AbortSignal): Promise<any> => {
    const additionalOptions = {
        dataType: 'json',
        externalUrl: true
    }
    const uri =  Env.statusPageAPIURL
    .clone()
    .setPath('/api/v2/incidents/unresolved.json');
    return getUri(uri, {
        signal: signal
    }, additionalOptions);
}

// GETs the scheduled maintenances from statuspage.io
export const getScheduledMaintenances = (signal: AbortSignal): Promise<any> => {
    const additionalOptions = {
        dataType: 'json',
        externalUrl: true
    }
    const uri =  Env.statusPageAPIURL
    .clone()
    .setPath('/api/v2/scheduled-maintenances.json');
    return getUri(uri, {
        signal: signal
    }, additionalOptions);
}